const user = {
  addUser: 'Add user',
  editUser: 'Edit User',
  firstName: 'First Name',
  requireFirstName: 'First Name field is required',
  lastName: 'Last Name',
  fullName: 'Fullname',
  phoneNumber: 'Phone Number',
  requirePhone: 'Phone number field is required',
  role: 'Role',
  requireRole: 'Role field is required',
  email: 'Email',
  requireEmail: 'Email field is required',
  password: 'Password',
  requirePassword: 'Password field is required',
  retypePassword: 'Retype password',
  requireRetypePassword: 'Retype Password field is required',
  accessAllTargets: 'Access all targets',
  configGroupAccess: 'Configure target groups access',
  groupName: 'Group name',
  description: 'Description',
  save: 'Save',
  cancel: 'Cancel',
  invalid: 'Invalid',

  users: 'Users',
  twoFactorAuthenticate: 'Two Factor Authentication',
  userEnabled: 'User Enabled',
  userLocked: 'User Locked',
  name: 'Name',

  enable: 'Enable',
  lock: 'Lock',
  delete: 'Delete',

  reset: 'Reset',

  accountSetting: 'Account Settings',
  passwordSetting: 'Password settings',
  passwordHistory: 'Password history',
  passwordMaxAge: 'Password max age',
  enableTwoFactorAuthenticate: 'Enable Two-factor Authentication for all users',
  sessionAndLogoutSettings: 'Session and Lockout Settings',
  sessionTimeout: 'Session Timeout (minutes)',
  maximumConsecutiveLoginFailue: 'Maximum Consecutive Login Failures',
  timeWindow: 'Time window (minutes)',
  logoutTime: 'Logout Time (minutes)',
  passwordHistoryTextHelper:
    'Number of unique new passwords before an old password can be reused. 0 to disable',
  passwordMaxAgeTextHelper:
    'Number of days that a password can be used before the user is requested to change it. 0 to disable',
  timeoutTextHelper:
    'User session will expire and users will be asked to login after time specified. 0 to disable',
  maximumConsecutiveTextHelper:
    'Number of consecutive login failures before account locks out. 0 to disable',
  timeWindowTextHelper:
    'Time in which the login failures have to happen for account lockout to happen. 0 to disable',
  lockTimeTextHelper:
    'Locked out accounts can login again after time specified. 0 to disable',

  requiredPasswordHistory: 'Password History is required',
  requiredPasswordMaxAge: 'Password Max Age is required',
  requiredSessionTimeout: 'Session Timeout is required',
  requiredMaximumConsecutiveLoginFailue:
    'Maximum Consecutive Login Failures is required',
  requiredTimeWindow: 'Time window is required',
  requireLogoutTime: 'Logout Time is required',

  createUserNotSuccess: 'Create user failed',
  updateUserNotSuccess: 'Update user failed',
  updateUserSuccess: 'Update user successfully',
  deleteUserNotSuccess: 'Delete user failed',
  deleteUserSuccess: 'Delete user successfully',
  enableUserSuccess: 'Enable user successfully',
  disableUserSuccess: 'Disable user successfully',

  changePassword: 'Change password',
  requiredOldPassword: 'Required old password',
  requiredNewPassword: 'Required new password',
  oldPassword: 'Old password',
  newPassword: 'New password',
  newPasswordRetype: 'Retype new password',
  requiredNewPasswordRetype: 'Required retype new password',
  passWordDoNotMatch: 'PassWord do not match',
  changePasswordSuccess: 'Change password successfully'
};

export default user;
